"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingDetailsModal = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var policy_billing_type_labels_1 = require("../../../utils/policy-billing-type-labels");
function BillingDetailsModal(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var policy = _a.policy, isOpen = _a.isOpen, onToggle = _a.onToggle;
    return (react_1.default.createElement(core_ui_1.Modal, { isOpen: isOpen, onToggle: onToggle },
        react_1.default.createElement(core_ui_1.ModalBody, null,
            react_1.default.createElement(core_ui_1.ModalHeader, { titleText: "Billing details", onClose: onToggle }),
            react_1.default.createElement(core_ui_1.Padding, { size: 24 },
                react_1.default.createElement(core_ui_1.BillingSpreadsheet, { value: {
                        premium: (_b = policy.billing.premium) !== null && _b !== void 0 ? _b : 0,
                        carrierPolicyFee: (_c = policy.billing.feesTaxes.carrierFee) !== null && _c !== void 0 ? _c : 0,
                        miscTaxesAndFees: (_d = policy.billing.feesTaxes.miscTaxesFees) !== null && _d !== void 0 ? _d : 0,
                        wholesaleFee: (_e = policy.billing.feesTaxes.wholesaleFee) !== null && _e !== void 0 ? _e : 0,
                        stateStampingFee: (_f = policy.billing.feesTaxes.stampingFee) !== null && _f !== void 0 ? _f : 0,
                        newfrontFee: (_g = policy.billing.feesTaxes.taxesFees) !== null && _g !== void 0 ? _g : 0,
                        stateTax: (_h = policy.billing.feesTaxes.surplusLinesStateTaxes) !== null && _h !== void 0 ? _h : 0,
                    } }),
                react_1.default.createElement(core_ui_1.Spacing, { height: 16 }),
                react_1.default.createElement(core_ui_1.Stack, { gap: 16, direction: "vertical" },
                    react_1.default.createElement(core_ui_1.StackedLineItem, { label: "Comission", items: [((_j = policy.billing.commisionPercent) !== null && _j !== void 0 ? _j : 0) + "%"] }),
                    react_1.default.createElement(core_ui_1.StackedLineItem, { label: "Billing type", items: [policy_billing_type_labels_1.POLICY_BILLING_TYPE_LABEL_MAP[policy.billing.billingType]] }))))));
}
exports.BillingDetailsModal = BillingDetailsModal;
